import { render, staticRenderFns } from "./EditFirstLastName.vue?vue&type=template&id=35d2fd42"
import script from "./EditFirstLastName.vue?vue&type=script&lang=js"
export * from "./EditFirstLastName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports